/**
 * Copyright (c) 2019 - 2023, all rights reserved.
 * State Of New Jersey Department Of Human Services
 * Division Of Family Development
 *
 * File: "app-init.service.ts"
 * Project: "mynjhelps"
 * File Created: "date created"
 * Author: "PROTECH"
 * Description: "Application Initialization Service.All Data Stores are loaded
 * in this Service and Control Handedover to Angular"
 *
 * History
 * -------
 * Last Modified: "date last modified"
 * Modified By: "PROTECH"
 * Update Comments: "reason for modification"
 * -----
 */
import { Injectable } from "@angular/core";
import { StorageService } from "@mynjhelps/storage";
import { DataStoreService } from "./shared/services/data-store.service";

@Injectable()
export class AppInitService {
  constructor(private dataStore: DataStoreService, private storageService: StorageService) { }
  /**
   * Initialize Datastore
   * @returns Promise
   */
  init(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.dataStore.loadDataStore().then(() => {
        resolve();
      });

    });
  }
}
